import { useState } from 'react'
import { generateError } from '../../helpers/errors'
import { mutations } from '../../resources'
import { PatchMessagingConversation } from '../../resources/messages/types'
import { patchMessagingConversation } from '../../store/messaging/actions'
import { useDispatch } from '../redux'

export const usePatchConversation = () => {
    const [inProgress, setInProgress] = useState(false)
    const dispatch = useDispatch()

    const patchConversation = (payload: PatchMessagingConversation): Promise<void> => {
        setInProgress(true)
        return mutations
            .updateMessagingConversationLastView(payload)
            .then((response) => {
                dispatch(patchMessagingConversation(response))
            })
            .catch((error) => {
                throw generateError(error)
            })
            .finally(() => {
                setInProgress(false)
            })
    }

    return {
        patchConversation,
        inProgress,
    }
}
